<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="500px"
    top="-175px"
    :footer="null"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :show-close="false"
    custom-class="update-ok-dialog"
  >
    <div class="update-dialog-view" :style="{ backgroundImage: bgImg }">
      <div class="update-top-tip">
        更新通知<span>NEW</span>
      </div>
      <!-- <p class="update-tip">更新包已准备就绪</p> -->
      <!-- <p class="update-error">如果更新失败，可<span @click="openClientPath">点击这里</span>手动安装最新版本</p> -->
      <div class="upload-text">
        <!-- 大工程师PC / 大工程师-企业版PC 显示的文案 -->
        <template v-if="isBigEngineerClient">
          <h3>亲爱的大工程师用户:</h3>
          <p>感谢您一直以来对平台的支持！该平台始终致力于建设装备制造业数字供应链平台，服务于广大工程师朋友的设计、询价、建库、交流等工作，并不断根据用户需求完善和修改各种功能，因此会经常升级，增强功能、提升使用价值。本次修改请您及时升级，充分利用资源平台，继续有效提高您的设计效率，实现与供应商的协同选型工作。</p>
        </template>
        <!-- 其他平台保持原文案 -->
        <template v-else>
          <h3>亲爱的工程师用户:</h3>
          <p>感谢您一直以来对我们平台的支持！该平台目前已正式归并到工信部中国工业互联网研究院，正式更名为“大国工匠”，开始作为国家级平台，全面建设全国装备制造业数字供应链平台，请及时升级，充分利用国家平台，继续有效提高您的设计效率，充分利用平台与供应商实现协同选型，详情请查询官网：<span @click="openGlobaDsclWeb">www.global-dsc.cn</span></p>
        </template>
      </div>
      <div class="update-btn">
        <div class="update-reset" @click="restart">立即重启</div>
        <div class="update-cancal" @click="hide">稍后更新</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {AppName,AppClientDownPath,WinForm,CheckLibs} from '@digital-supply-chain/module'
import {DomainService} from '@/libs';
// 客户端版本升级检测程序
import { setClientUpdate } from "../clientUpdate";

export default {
  data() {
    return {
      dialogVisible: false,
      clientPath: AppClientDownPath[WinForm.md.getAppName()] || AppClientDownPath[AppName.Dggj],

      bgImg: `url(${DomainService.PublicPath}resource/updatebg.png)`
    }
  },
  computed: {
    // ----------- 是否是大工程师PC或大工程师-企业版PC 方法
    isBigEngineerClient() {
      // 大工程师个人版 或 大工程师企业版
      return CheckLibs.isBigEngineer() || CheckLibs.isBigEngineerE();
    }
  },
  mounted() {
    if (!window.md) return;
    WinForm.md.$on('engineer_client_download_ok', () => {
      this.dialogVisible = true;
    })
    WinForm.md.$on('engineer_client_download_hide', () => {
      this.dialogVisible = false;
    })
    setClientUpdate();
  },
  methods: {
    show() {
      WinForm.md.$emit('engineer_client_download_ok');
    },
    hide() {
      WinForm.md.$emit('engineer_client_download_hide');
    },
    restart() {
      window.md.restart();
    },
    openGlobaDsclWeb() {
      WinForm.md.openUrl('https://www.global-dsc.cn')
    },
    openClientPath() {
      WinForm.md.openUrl(this.clientPath)
    }
  },
}
</script>

<style lang="less">
.update-dialog-view{
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding-top: 100px;
}
.el-dialog.update-ok-dialog{
  height: 350px;
  margin: 0;
  position: absolute;
  left: 50%;
  margin-left: -250px;
  top: 50%;

  .upload-text{
    padding: 0 30px;
    line-height: 24px;
    span{
      text-decoration: underline;
      cursor: pointer;
      color: #5AA8EA;
    }
  }

  .update-top-tip{
    position: absolute;
    left: 28px;
    top: 24px;
    font-size: 22px;
    font-weight: bold;
    color: #FFFFFF;
    span{
      height: 18px;
      background: #FFFFFF;
      border-radius: 9px;
      font-size: 12px;
      color: #28334F;
      padding: 0 4px;
      margin-left: 8px;
      vertical-align: middle;
    }
  }
  
  .el-dialog__header{
    display: none;
  }
  .el-dialog__footer{
    display: none;
  }
  .el-dialog__body{
    padding: 0;
  }
  .update-btn{
    display: flex;
    justify-content: center;
    margin-top: 23px;
  }
  .update-tip{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #666666;
    line-height: 25px;
    text-align: center;
  }
  .update-error{
    font-size: 13px;
    color: #999999;
    line-height: 20px;
    text-align: center;
    span{
      text-decoration: underline;
      cursor: pointer;
      color: #5AA8EA;
    }
  }
  .update-reset{
    width: 160px;
    height: 30px;
    background: linear-gradient(180deg, #5AA8EA, #7E7BFB);
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    margin-right: 20px;
    cursor: pointer;
  }
  .update-cancal{
    width: 100px;
    height: 30px;
    border: 1px solid #D7D6D6;
    border-radius: 15px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
